<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb"/>
    <div class="flexBox">
      <text-title mainTitle="查看最新政策" subheading="" />
      <div class="header-btn-box">
        <a @click="strategyCenter">返回</a>
      </div>
    </div>
    <form>
      <div class="form-line">
        <div class="line-text">政策标题：</div>
        <div class="line-info">{{detailInfo.title || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">发文单位：</div>
        <div class="line-info">{{detailInfo.publishDept || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">发文日期：</div>
        <div class="line-info">{{detailInfo.publishTime || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">政策分类：</div>
        <div class="line-info">{{detailInfo.type1Name || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">政策级别：</div>
        <div class="line-info">{{detailInfo.areaName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">支持产业：</div>
        <div class="line-info">{{detailInfo.businessName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">政策原文：</div>
        <div v-if="detailInfo.information" class="line-info" style="color: #00a0e6;cursor: pointer;" @click="seeOriginalText">查看</div>
        <div class="line-info" v-else>无</div>
      </div>
      <div class="form-line">
        <div class="line-text">浏览量：</div>
        <div class="line-info">{{detailInfo.viewNumber || '0'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">收藏量：</div>
        <div class="line-info">{{detailInfo.collectNumber || '0'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">政策要点：</div>
        <div class="line-info" v-html="detailInfo.content || '无'"></div>
      </div>
    </form>
  </div>
</template>

<script>
  import BreadCrumb from '../../../components/common/di-ding/common/bread-crumb'
  import {errorHandler} from '../../../utils/errorHandler'
  import InputTree from '../../../components/common/inputs/input-tree'
  import {api} from '../../api/EnterpriseFavour'
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import {nSuccess} from '../../../utils/notice'

  export default {
    components: {
      TextTitle,
      Breadcrumb,
      InputTree,
      BreadCrumb
    },
    name: 'controller-current',
    data () {
      return {
        config: {
          breadcrumb: [{
            value: '惠企服务',
            name: 'latest-policy-manage'
          }, {
            value: '最新政策'
          }],
        },
        code: '',
        detailInfo: {}
      }
    },
    created () {
      this.code = this.$route.params.id
      this.getNewestPolicyDetail()
    },
    methods: {
      getNewestPolicyDetail () {
        this.$axios.get(`${api.getNewestPolicyDetail}/${this.code}`, {})
          .then(res => {
            let data = res.data.data
            this.detailInfo = data
          })
          .catch(errorHandler('获取数据失败'))
      },
      strategyCenter () {
        this.$router.push({
          name: 'latest-policy-manage'
        })
      },
      seeOriginalText () {
        window.open(this.detailInfo.information, '_blank')
      }
    }
  }
</script>

<style scoped>
  .flexBox {
    display: flex;
    justify-content: space-between;
  }
  .header-btn-box {
    margin: 20px 0 10px 0;
    color: #337ab7;
    font-size: 14px;
  }
  .header-btn-box a{
    margin-right: 40px;
    cursor: pointer;
  }
  .header-btn-box a:hover{
    color: #00a0e6;
  }
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .form-line {
    margin: 30px 0;
    display: flex;
    justify-content: flex-start;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
    width: 120px;
    text-align: right;
  }
  .line-info {
    flex: 1;
  }
</style>



// WEBPACK FOOTER //
// src/view/EnterpriseFavour/LatestPolicy/LatestPolicyCurrent.vue